import React, { useEffect } from 'react'
import Head from 'next/head';
import Layout from '../ResearchGoal/Layout';
import NewBusiness from '@/app/Components/New Business Development/NewBusiness';

export async function generateStaticParams() {

  return ['.html']
}

const RDTechScouting = () => {

  useEffect(() => {
    document.body.style.margin = '0';
  }, []);

  return (
    <div>
      <Head>

        <title>Ideapoke AI-Powered New Business Development</title>
        <link rel="shortcut icon" href="/ipimages/enterprise/images/ufoant.ico" />
        <link rel="icon" type="image/ico" href="/ipimages/enterprise/images/ufoant.ico" />
        <link rel="apple-touch-icon" href="/ipimages/enterprise/images/ufoant.ico" />
        <meta
          content="Power your innovation with Ideapoke's AI tools for business development. Strategize, identify new opportunities, and navigate regulatory compliance for successful market entry."
          name="description"

        />
        <meta
          content="Ideapoke AI-Powered New Business Development"
          property="og:title"
        />
        <meta
          content="Power your innovation with Ideapoke's AI tools for business development. Strategize, identify new opportunities, and navigate regulatory compliance for successful market entry."
          property="og:description"
        />
        <meta
          content="AI innovation tools, business development, new opportunities, market entry strategy, regulatory compliance"
          property="og:keywords"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="og:image"
        />
        <meta
          content="Ideapoke AI-Powered New Business Development"
          property="twitter:title"
        />
        <meta
          content="Power your innovation with Ideapoke's AI tools for business development. Strategize, identify new opportunities, and navigate regulatory compliance for successful market entry."
          property="twitter:description"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="twitter:image"
        />
        <meta
          content="AI innovation tools, business development, new opportunities, market entry strategy, regulatory compliance"
          property="og:keywords"
        />

        <meta property="og:type" content="website" />
        <meta content="summary_large_image" name="twitter:card" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
      </Head>

      <Layout>
        <NewBusiness />
      </Layout>
    </div>
  )
}
export default RDTechScouting;
